<div [innerHTML]="printGraph | safe: 'html'"></div>
